// The Library's date groups: Today, Yesterday, then Earlier, by the reader's own calendar day.
export type LibraryDateGroup = 'today' | 'yesterday' | 'earlier';

export const DATE_GROUPS: readonly LibraryDateGroup[] = ['today', 'yesterday', 'earlier'];

export function libraryDateGroup(value: string, now = new Date()): LibraryDateGroup {
  const time = new Date(value).getTime();
  if (!Number.isFinite(time)) return 'earlier';
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  if (time >= today) return 'today';
  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1).getTime();
  return time >= yesterday ? 'yesterday' : 'earlier';
}

/** The items in their date groups, newest group first; a group with nothing in it is left out. */
export function groupByDate<T>(
  items: readonly T[],
  dateOf: (item: T) => string,
  now = new Date(),
): { group: LibraryDateGroup; items: T[] }[] {
  const groups = new Map<LibraryDateGroup, T[]>(DATE_GROUPS.map((group) => [group, []]));
  for (const item of items) groups.get(libraryDateGroup(dateOf(item), now))?.push(item);
  return DATE_GROUPS.map((group) => ({ group, items: groups.get(group) ?? [] })).filter(
    (entry) => entry.items.length > 0,
  );
}
